<template>
  <div
    class="conversation"
    :class="{ active: unreadCount }"
    @click="handleOpenChat"
  >
    <img class="avatar" :src="user.display.thumbnail" alt="avatar" />
    <div class="info">
      <span class="username">{{ user.display.name }}</span>
      <span class="message">{{ lastMessage }}</span>
    </div>
    <span v-if="unreadCount" class="unread">{{ unreadCount }}</span>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
export default {
  props: ["conversation"],
  // data: function () {
  //   return {
  //     showUnread: true,
  //   }
  // },
  computed: {
    ...mapGetters("Message", ["conversationSearchText", "chatUser"]),
    user () {
      for (let user of this.conversation.users) {
        if (this.chatUser.display.name !== user.display.name) {
          return user
        }
      }
      return this.conversation.users[1]
    },
    lastMessage () {
      if (this.conversation.last_message && this.conversation.last_message.type) {
        switch (this.conversation.last_message.type) {
          case "VOD_REVIEW_SUMMARY":
            return "Your Pro Video Review is ready."
          case "SESSION_START":
          case "SESSION_INITIATED":
            return "Your session has started."
          case "SESSION_END":
            return "Your session has ended."
          case "SESSION_SUMMARY":
            return "Your Session Summary is ready."
          case "REPORT_CARD_SUBMISSION":
            return "Your Report Card is ready."
          case "SESSION_BOOKED":
            return "Your session is scheduled"
          case "SESSION_CHECKED_IN":
          case "SESSION_START_IN_HOUR":
            return "Your session is about to start"
          case "CHECK_IN_FOR_SESSION":
            return "Time to check in for your session"
          case "CLOSE_UNCHECKED_SESSION":
            return "You missed a session"
          case "CLOSE_UNINITIATED_SESSION":
            return "Session closed, we will refund credits to you"
          default:
            return this.conversation.last_message.body
        }
      }
      return ""
    },
    unreadCount () {
      return this.conversation.unread_count
    },
  },
  methods: {
    ...mapActions("Message", ["openChat"]),
    handleOpenChat () {
      // this.showUnread = false
      this.openChat(this.conversation)
    },
  },

}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_mixins.scss";
@import "@/assets/style/_variables.scss";
.conversation {
  display: flex;
  align-items: center;
  text-align: left;
  width: 100%;
  padding: 1.25rem 0;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  &:hover {
    background-color: #f8f8f8;
  }
  &.active {
    .info {
      max-width: calc(100% - 9rem);
      .username {
        color: #333;
      }
      .message {
        color: #333;
      }
    }
  }
  .avatar {
    width: 3.5rem;
    border-radius: 50%;
    margin-right: 1rem;
  }
  .info {
    display: flex;
    flex-direction: column;
    max-width: calc(100% - 4.5rem);
    .username {
      font-family: $font-roboto;
      font-weight: 700;
      font-size: 1.4rem;
      margin-bottom: 0.5rem;
      color: #999;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .message {
      font-family: $font-roboto;
      font-size: 1.2rem;
      line-height: 1.4rem;
      color: #999;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .unread {
    margin-left: auto;
    font-family: $font-display;
    font-weight: 700;
    font-size: 1.2rem;
    text-align: center;
    color: #fff;
    background-color: #f14950;
    height: 2.1rem;
    width: 2.1rem;
    margin-right: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/message_widget/Conversation.vue